import React from 'react';

const ExhibitionsPage = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold text-center mb-8">Exhibitions</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-white rounded-lg shadow-md p-6">
            <h3 className="text-xl font-semibold mb-4">Current Exhibitions</h3>
            <p className="text-gray-600">Discover our current art exhibitions and featured collections.</p>
          </div>
          <div className="bg-white rounded-lg shadow-md p-6">
            <h3 className="text-xl font-semibold mb-4">Upcoming Shows</h3>
            <p className="text-gray-600">Stay tuned for exciting upcoming exhibitions and events.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExhibitionsPage;